export function isValidSolanaAddress(address: string): boolean {
  // Solana addresses are 44 characters long and Base58 encoded
  const base58Regex = /^[1-9A-HJ-NP-Za-km-z]{44}$/;
  return base58Regex.test(address);
}